import script from "./RangeBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RangeBar.vue?vue&type=script&setup=true&lang=ts"

import "./RangeBar.vue?vue&type=style&index=0&id=4640de2e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4640de2e"]])

export default __exports__